<template>
  <div>
    <get-help :active="active" @change="change" @close="close"></get-help>
    <Jumph5 :active="active" @change="change" @close="close"></Jumph5>
    <goAppShop v-if="!hideAppShopEntry" :active="active" @change="change" @close="close"></goAppShop>
    <!-- <join-train :active="active" @change="change" @close="close"></join-train> -->
  </div>
</template>
<script>
export default {
  name: 'Help',
  components: {
    GetHelp: () => import('./components/GetHelp'),
    Jumph5: () => import('./components/Jumph5'),
    goAppShop: () => import('./components/goAppShop'),
  },
  data() {
    return {
      active: '',
    };
  },
  computed: {
    hideAppShopEntry() {
      const currentDomainConfig = this.$store.state.app.currentColorLogo || {};
      return currentDomainConfig.hideAppShopEntry;
    },
  },
  methods: {
    change(type) {
      this.active = type;
    },
    close(type) {
      setTimeout(() => {
        if (this.active === type) {
          this.active = '';
        }
      }, 100);
    },
  },
};
</script>
